<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">Borderô</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <table class="table-fees">
          <tr>
            <th></th>
            <th>Bilheteria</th>
            <th>Online</th>
          </tr>
          <tr>
            <td>Cartão de crédito (%)</td>
            <td align="right"><input v-model="feeTicketCredit" type="number" step="0.01" placeholder="%" /></td>
            <td align="right"><input v-model="feeOnlineCredit" type="number" step="0.01" placeholder="%" /></td>
          </tr>
          <tr>
            <td>Cartão de débito (%)</td>
            <td align="right"><input v-model="feeTicketDebit" type="number" step="0.01" placeholder="%" /></td>
          </tr>
          <tr>
            <td>Boleto</td>
            <td></td>
            <td align="right"><money v-model="feeOnlineBillet" placeholder="Valor" /></td>
          </tr>
          <tr>
            <td>PIX (%)</td>
            <td align="right"><input v-model="feeTicketPix" type="number" step="0.01" placeholder="%" /></td>
            <td align="right"><input v-model="feeOnlinePix" type="number" step="0.01" placeholder="%" /></td>
          </tr>
          <tr>
            <td>Dinheiro (%)</td>
            <td align="right"><input v-model="feeTicketCash" type="number" step="0.01" placeholder="%" /></td>
            <td></td>
          </tr>
        </table>
        <div class="row-settings">
          <div class="column-settings-3">
            <label>Taxa de Impressão</label>
            <money v-model="feeTicketPrint" placeholder="Valor" style="max-width: 140px" />
          </div>
          <div class="column-settings-3">
            <label>Taxa de Emissão</label>
            <money v-model="feeOnlinePrint" placeholder="Valor" style="max-width: 140px" />
          </div>
        </div>
        <div class="row-settings">
          <div class="column-settings-3">
            <label>% Teatro</label>
            <input v-model="feeBusiness" type="number" step="0.01" placeholder="%" style="max-width: 140px" />
          </div>
        </div>
        <div style="margin-top: 10px; text-align: right">
          <button @click="update" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Atualizar</span></button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { get, update } from '../api/showBordero'

export default {
  name: 'show-bordero',
  props: ['id', 'close', 'name', 'date'],
  data () {
    return {
      loading: false,
      error: [],
      feeTicketCredit: 0,
      feeTicketDebit: 0,
      feeTicketPix: 0,
      feeTicketCash: 0,
      feeOnlineCredit: 0,
      feeOnlineBillet: 0,
      feeOnlinePix: 0,
      feeTicketPrint: 0,
      feeOnlinePrint: 0,
      feeBusiness: 0,
      fees: []
    }
  },
  async mounted () {
    try {
      const data = await get(this.id)
      this.fees = data
      this.feeTicketCredit = data.find(x => x.name === 'Bilheteria - Cartão de crédito').fee
      this.feeTicketDebit = data.find(x => x.name === 'Bilheteria - Cartão de débito').fee
      this.feeTicketPix = data.find(x => x.name === 'Bilheteria - PIX').fee
      this.feeTicketCash = data.find(x => x.name === 'Bilheteria - Dinheiro').fee
      this.feeOnlineCredit = data.find(x => x.name === 'Online - Cartão de crédito').fee
      this.feeOnlineBillet = data.find(x => x.name === 'Online - Boleto').fee
      this.feeOnlinePix = data.find(x => x.name === 'Online - PIX').fee
      this.feeTicketPrint = data.find(x => x.name === 'Taxa de Impressão').fee
      this.feeOnlinePrint = data.find(x => x.name === 'Taxa de Emissão').fee
      this.feeBusiness = data.find(x => x.name === '% Teatro').fee
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    async update () {
      if (this.loading) return false
      this.loading = true
      this.error = []
      try {
        await update(this.id, this.fees.map(x => {
          switch (x.name) {
            case 'Bilheteria - Cartão de crédito':
              return { id: x.id, fee: this.feeTicketCredit }
            case 'Bilheteria - Cartão de débito':
              return { id: x.id, fee: this.feeTicketDebit }
            case 'Bilheteria - PIX':
              return { id: x.id, fee: this.feeTicketPix }
            case 'Bilheteria - Dinheiro':
              return { id: x.id, fee: this.feeTicketCash }
            case 'Online - Cartão de crédito':
              return { id: x.id, fee: this.feeOnlineCredit }
            case 'Online - Boleto':
              return { id: x.id, fee: this.feeOnlineBillet }
            case 'Online - PIX':
              return { id: x.id, fee: this.feeOnlinePix }
            case 'Taxa de Impressão':
              return { id: x.id, fee: this.feeTicketPrint }
            case 'Taxa de Emissão':
              return { id: x.id, fee: this.feeOnlinePrint }
            case '% Teatro':
              return { id: x.id, fee: this.feeBusiness }
            default:
              return { id: x.id, fee: x.fee }
          }
        }))
        this.close()
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.box {
  max-width: 500px!important;
}

.row-settings {
  display: flex;

  label, input {
    display: block;
  }
}

.column-settings, .column-settings-3 {
  width: 100%;
  margin: 10px 0;
}

.table-fees {
  max-width: 530px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 15px;
  padding: 10px;

  th {
    color: $primary-color;
    text-align: right;
  }

  td {
    font-size: 0.9em;
    font-weight: 400;
    text-transform: uppercase;
    color: #666;
  }

  input {
    max-width: 100px;
  }
}
</style>
